import { Trans } from "@lingui/react/macro";
import { Button } from "@rakazo/ui-web";
import { Plus } from "lucide-react";
import { useDrokAccess } from "./use-drok-access";

/** The roster's empty state: IT gets the New bot button, everyone else (and while loading) gets the message. */
export function DrokEmptyState({ onCreate }: { onCreate: () => void }) {
  if (useDrokAccess() === "manage-agents") {
    return (
      <Button onClick={onCreate}>
        <Plus size={16} aria-hidden="true" />
        <Trans>New bot</Trans>
      </Button>
    );
  }
  return (
    <p data-testid="no-agents-assigned" className="text-sm text-muted-foreground">
      <Trans>No agents have been assigned to you yet. Contact IT.</Trans>
    </p>
  );
}
